var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var Link = require('react-router').Link;

var Clinical = createReactClass({

  render: function(){
    return (
        <div className="content">
            <Helmet
                title="History of Presenting Illness (HPI) | Pain History | MyGiHealth"
                titleTemplate = "%s"
                meta={[
                    {"property": "description", "content": 'By helping patients easily document their "History of Presenting Illness" (HPI), MyGiHealth improves outcomes and the patient-physician relationship.'}
                ]}
            />
            <div className="content-header-wrapper">
				<div className="row column content-header">
					<h1>Clinical Use</h1>
					<p>Work with your GI specialist to assess, track and manage your GI symptoms.</p>
				</div>
			</div>
            <div id="intro">
                <div className="row">
                    <div className="medium-6 column">
                        <div className="text-wrapper-1">
                            <p>Researchers at Cedar-Sinai Medical Center, University of Michigan and UCLA were studying the way that technology is changing the healthcare landscape, and learned that electronic health records are helpful… to billers, administrators, and the like.</p>
                            <p>But to patients and their doctors, they’re not enough. Electronic records store information, sure, but they don’t enhance patients’ relationship with their doctors. Using this insight as a springboard, the research team created a new system that re-defines how patients and doctors connect with one another.</p>
                            <p>It’s a system custom-built by patients and doctors, for patients and doctors. It’s called MyGiHealth. Doctors can prescribe use of the app before, during, and after an initial consultation with a patient to create an efficient and accurate way for the patient to provide their symptom history.</p>
                        </div>
                    </div>
                    <div className="medium-6 column end">
                        <div className="text-wrapper-2">
                            <p>The patient-physician relationship is improved as the physician can spend more time learning about the patient, rather than taking a patient history. The system doesn’t forget to ask important questions that can often be forgotten by busy physicians. The physician can customize the educational materials that the patient can access to taylor the experience just for the patient.</p>
                            <blockquote><p>Patients benefit from recording their symptoms on the own time, and from the privacy of their own homes, or in waiting rooms</p></blockquote>
                            <blockquote><p><a href="http://www.latimes.com/business/la-fi-computer-beats-doctors-at-recording-patient-symptoms-cedars-sinai-study-finds-20141209-story.html">A recent landmark study shows the app outperforms doctors in gathering information from patients with GI conditions – this is the first published example of an mHealth app providing measurable clinical assessment value.</a></p></blockquote>
                        </div>
                    </div>
                </div>
            </div>
            <div id="history">
                <div className="row">
                    <div className="large-6 column">
                        <div className="illustration"></div>
                    </div>
                    <div className="large-6 column">
                        <div className="text-wrapper">
                            <h2>History of Presenting Illness</h2>
                            <p>The system uses smart logic to “interview” users about their GI symptoms and writes a report that allows doctors to quickly assess symptoms and make diagnoses. A recent landmark study shows the app outperforms doctors in gathering information from patients with GI conditions*. This is the first published example of an mHealth app providing measurable clinical assessment value.</p>
                            <p className="ref">* Almario CV, et al. Computer-generated vs.physician-documnted history of present illness (HPI): results of a blinded comparison. Am J Gastroenterol. 2015 Jan;110(1):170-9.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="enabling">
                <div className="row column">
                    <div className="text-wrapper">
                        <h2>Enabling Your Patients</h2>
                        <p>MyGiHealth democratizes the medical chart by allowing the patient, the true expert, to drive the narrative and convey the facts of what’s been happening. By enabling patients to tell their own story, MyGiHealth ensures that key details are recorded and presented in “doctor speak” so your healthcare provider can hear you, loud and clear.</p>
                        <blockquote><p>When patients can see and contribute to their medical chart, it becomes a tool for patients, not just a record of what doctors do to patients.</p></blockquote>
                    </div>
                </div>
            </div>
            <div id="web">
                <div className="row">
                    <div className="large-6 large-push-6 column">
                        <div className="video-wrapper">
                            <div className="video-wrapper-inner">
                                <iframe width="900" height="506" src="https://www.youtube.com/embed/OWPi0oT8sEQ?feature=oembed" allowFullScreen title=" "></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="large-6 large-pull-6 column">
                        <div className="text-wrapper">
                            <h2>Get Started with MyGiHealth</h2>
                            <p>It's easy to get started monitoring, understanding and managing Gi symptoms.</p>
                            <p><Link className={'button success' + (this.props.auth.token ? ' invisible' : '')} to="/register">Register</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
});

module.exports = Clinical;



// WEBPACK FOOTER //
// ./src/common/routes/clinical/components/clinical.jsx